<ng-container *ngIf="flightStatus | async; let vm">
  <div
    class="jb-max-width page-margin center flex flex-wrap pt3 pb3 pb2-ns justify-center flex-row-ns flex-column"
  >
    <div
      class="jb-grid one-up grid-offset-l gr-unset flex flex-column flex-row-ns w-100"
    >
      <jb-tabs
        #jbTabs
        [theme]="'light'"
        [isDynamicBase]="true"
        (tabSelected)="selectTab($event)"
        *ngIf="vm.selectedTabId"
      >
        <div *ngFor="let tab of vm.flightTrackerTabs; let i = index">
          <jb-tab-panel
            class="core-blue"
            [label]="tab.title"
            [isActive]="tab.id === vm.selectedTabId"
          >
            <div
              *ngIf="tab.id === vm.selectedTabId"
              class="w-100 mt4 flex justify-center"
            >
              <div class="flex w-100" [ngSwitch]="tab.id">
                <ng-container *ngSwitchCase="FlightTrackerTabId.byRoute">
                  <ng-container
                    *ngTemplateOutlet="byRouteTemplate"
                  ></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="FlightTrackerTabId.byFlight">
                  <ng-container
                    *ngTemplateOutlet="byFlightNumberTemplate"
                  ></ng-container>
                </ng-container>
              </div>
            </div>
          </jb-tab-panel>
        </div>
      </jb-tabs>

      <div
        class="flex flex-column w-100 items-center mt3 mt1-l justify-center"
      ></div>
    </div>
  </div>

  <ng-template #byRouteTemplate>
    <form
      [formGroup]="byRouteForm"
      class="w-100 flex flex-column items-center"
      (ngSubmit)="getSearchResults(FlightTrackerTabId.byRoute)"
      #byRouteFormReference="ngForm"
    >
      <div class="flex flex-column flex-row-l w-100 city-pair-spacing">
        <div class="w-100 w-two-thirds-l mb1 mb0-l">
          <dot-city-pair-selector
            [id]="'FLIGHT_TRACKER'"
            [formControl]="byRouteForm.controls.cityPair"
            [origin]="byRouteForm.controls.cityPair.value.origin"
            [destination]="byRouteForm.controls.cityPair.value.destination"
            [content]="vm.bookerResponse.citySelector"
            [swappable]="true"
            [formWrapper]="formWrapper"
            [origins]="vm.originAirports['originAirports']"
            [destinations]="vm.destinationAirports['destinationAirports']"
            [hideLegend]="true"
            [customLegendMessage]="
              vm.flightTrackerResponse.hidingPartnerAirlinesMsg
            "
            [showValidationErrors]="byRouteFormReference.submitted"
            (userChangedDestination)="returnFocus()"
          >
          </dot-city-pair-selector>
        </div>
        <div class="w-100 w-third-l pl1-l date-dropdown-city-pair">
          <jb-select
            (selectChange)="onByRouteDateChange()"
            [placeholder]="vm.flightTrackerResponse.dropdownLabel"
            [formControl]="byRouteForm.controls.departureDate"
          >
            <jb-select-option
              *ngFor="let dateOption of vm.dateOptions"
              [name]="dateOption.name"
              [id]="dateOption.id"
              [value]="dateOption.value"
            >
            </jb-select-option>
          </jb-select>
        </div>
      </div>

      <button
        type="submit"
        jbButton
        class="mt5 db-l dn-override submit-override nowrap flex-grow-1"
        theme="ctaPrimary"
        [isPaired]="false"
        [isRounded]="true"
      >
        <span *ngIf="!vm.formSubmitting">{{
          vm.flightTrackerResponse.checkStatusBtn
        }}</span>
        <jb-icon
          *ngIf="vm.formSubmitting"
          name="loading"
          fill="white"
          width="4em"
        ></jb-icon>
      </button>
    </form>
  </ng-template>

  <ng-template #byFlightNumberTemplate>
    <form
      [formGroup]="byFlightNumberForm"
      class="w-100 flex flex-column items-center"
      (ngSubmit)="getSearchResults(FlightTrackerTabId.byFlight)"
      #byFlightNumberFormReference="ngForm"
    >
      <div class="flex flex-column flex-row-ns w-100 justify-center">
        <div class="fl w-100 w-50-ns w-third-l slate-gray flight-num-mt">
          <jb-form-field-container
            type="primary"
            [ngClass]="{
              mb3:
                byFlightNumberFormReference.submitted &&
                this.byFlightNumberForm.controls.flightNumber.invalid
            }"
          >
            <jb-input-label>{{
              vm.flightTrackerResponse.flightNoInputLabel
            }}</jb-input-label>
            <input
              class="mb1 mb0-ns"
              maxlength="7"
              #flightNumberInput
              jbInput
              type="text"
              [formControl]="byFlightNumberForm.controls.flightNumber"
            />
            <jb-error
              [showErrorIf]="
                byFlightNumberFormReference.submitted &&
                this.byFlightNumberForm.controls.flightNumber.invalid
              "
            >
              <span>{{ vm.flightTrackerResponse.flightNoErrorMsg }}</span>
              <jb-sr-only
                >Error:
                {{ vm.flightTrackerResponse.flightNoErrorMsg }}</jb-sr-only
              >
            </jb-error>
          </jb-form-field-container>
        </div>
        <div class="fl w-100 w-50-ns w-third-l pl1-ns date-dropdown-flight-no">
          <jb-select
            [placeholder]="vm.flightTrackerResponse.dropdownLabel"
            [formControl]="byFlightNumberForm.controls.departureDate"
          >
            <jb-select-option
              *ngFor="let dateOption of vm.dateOptions"
              [name]="dateOption.name"
              [id]="dateOption.id"
              [value]="dateOption.value"
            >
            </jb-select-option>
          </jb-select>
        </div>
      </div>

      <button
        type="submit"
        jbButton
        theme="ctaPrimary"
        class="mt5 db-l dn-override submit-override nowrap flex-grow-1"
        [isPaired]="false"
        [isRounded]="true"
      >
        <span *ngIf="!vm.formSubmitting">{{
          vm.flightTrackerResponse.checkStatusBtn
        }}</span>
        <jb-icon
          *ngIf="vm.formSubmitting"
          name="loading"
          fill="white"
          width="4em"
        ></jb-icon>
      </button>
    </form>
  </ng-template>

  <div *ngIf="showResults">
    <jb-flight-tracker-results
      *ngIf="flightResults$ | async; let results"
      (refreshStatus)="getSearchResults(vm.selectedTabId)"
      [flightTrackerDirectResults]="results.directFlightResults"
      [flightTrackerConnectingResults]="results.connectingFlightResults"
      [flightTrackerError]="results.error"
      [noResultsError]="messages.noResults"
      [serviceError]="messages.serviceError"
      [departureDate]="results.departureDate"
    >
    </jb-flight-tracker-results>
    <jb-flight-tracker-mobile-alert-label
      *ngIf="!vm.flightResults"
      [mobileAlertCopy]="vm.flightTrackerResponse.mobileAlertLabel"
    ></jb-flight-tracker-mobile-alert-label>
  </div>
</ng-container>
